/* eslint react/prop-types: 0 */

import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Icon } from "semantic-ui-react";
import { LogoProv, logo, logoBiro } from "../assets/images";
import { isBiro, isBiroOnly } from "../utils/helper";

export const Sidebar = (props) => {
  const user = useSelector((state) => state.main.dataUser);
  const [konten, setKonten] = React.useState(false);
  const [indikatorKesehatan, setIndikatorKesehatan] = React.useState(false);

  const { pathname } = useLocation();
  const path = pathname.split("/")[1];

  return (
    <div className={classNames("sidebar", { "is-open": props.isOpen })} style={{ height: "100vh" }}>
      <div  >
        <div className="sidebar-header d-flex justify-content-md-center" >
          <img className="m-4 logo--sidebar" src={logoBiro} alt="Biro BIA" />
          <span className="ml-auto" color="info" onClick={props.toggle} style={{ color: "#000000" }}>
            &times;
          </span>
          <img className="m-4 logo--sidebar" src={logo} alt="Provinsi Jawa Barat" />
          <span className="ml-auto" color="info" onClick={props.toggle} style={{ color: "#2196F3" }}>
            &times;
          </span>
        </div>
      </div>
      <div className="side-menu" style={{ marginTop: '16px' }}>
        <Nav vertical className="list-unstyled pb-3 px-3">
          <NavItem>
            <NavLink className={path === "" ? "sidebar-active" : ""} tag={Link} to="">
              <span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.8">
                    <path
                      d="M8.33333 2.5H2.5V8.33333H8.33333V2.5Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17.5 2.5H11.6667V8.33333H17.5V2.5Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17.5 11.6667H11.6667V17.5001H17.5V11.6667Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.33333 11.6667H2.5V17.5001H8.33333V11.6667Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </span>
              &nbsp;&nbsp;Dashboard
            </NavLink>
            <NavLink className={path === "report" ? "sidebar-active" : ""} tag={Link} to="/report">
              <span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                      d="M10 16.6673V8.33398"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15 16.6673V3.33398"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5 16.6673V13.334"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </span>
              &nbsp;&nbsp;Laporan Keuangan
            </NavLink>

            <NavLink className={path === "deviden" ? "sidebar-active" : ""} tag={Link} to="/deviden">
              <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 20V10" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 20V4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6 20V14" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              &nbsp;&nbsp;PMD & Deviden
            </NavLink>

            {/* <NavLink className={path === "anggaran" ? "sidebar-active" : ""} tag={Link} to="/anggaran">
              <span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                      d="M11.6668 1.66602H5.00016C4.55814 1.66602 4.13421 1.84161 3.82165 2.15417C3.50909 2.46673 3.3335 2.89065 3.3335 3.33268V16.666C3.3335 17.108 3.50909 17.532 3.82165 17.8445C4.13421 18.1571 4.55814 18.3327 5.00016 18.3327H15.0002C15.4422 18.3327 15.8661 18.1571 16.1787 17.8445C16.4912 17.532 16.6668 17.108 16.6668 16.666V6.66602L11.6668 1.66602Z"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11.6665 1.66602V6.66602H16.6665"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.3332 10.834H6.6665"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.3332 14.166H6.6665"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.33317 7.5H7.49984H6.6665"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </span>
              &nbsp;&nbsp;Anggaran
            </NavLink> */}
            <NavLink
              className="cursor-pointer"
              to="/indikator-kesehatan"
              onClick={() => setIndikatorKesehatan(!indikatorKesehatan)}
            >
              <span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                      d="M11.6668 1.66602H5.00016C4.55814 1.66602 4.13421 1.84161 3.82165 2.15417C3.50909 2.46673 3.3335 2.89065 3.3335 3.33268V16.666C3.3335 17.108 3.50909 17.532 3.82165 17.8445C4.13421 18.1571 4.55814 18.3327 5.00016 18.3327H15.0002C15.4422 18.3327 15.8661 18.1571 16.1787 17.8445C16.4912 17.532 16.6668 17.108 16.6668 16.666V6.66602L11.6668 1.66602Z"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11.6665 1.66602V6.66602H16.6665"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.3332 10.834H6.6665"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.3332 14.166H6.6665"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.33317 7.5H7.49984H6.6665"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </span>
              &nbsp;&nbsp;Indikator Kesehatan
            </NavLink>
            {isBiro() ? (
              <>
                <NavLink
                  className={indikatorKesehatan ? (path === "aspek-keuangan" ? "sidebar-active" : "d-block") : "d-none"}
                  tag={Link}
                  to="/aspek-keuangan"
                >
                  &ensp;&ensp;&ensp;&ensp;&ensp;Aspek Keuangan
                </NavLink>
                <NavLink
                  className={indikatorKesehatan ? (path === "aspek-operasional" ? "sidebar-active" : "d-block") : "d-none"}
                  tag={Link}
                  to="/aspek-operasional"
                >
                  &ensp;&ensp;&ensp;&ensp;&ensp;Aspek Operasional
                </NavLink>
                <NavLink
                  className={indikatorKesehatan ? (path === "aspek-administrasi" ? "sidebar-active" : "d-block") : "d-none"}
                  tag={Link}
                  to="/aspek-administrasi"
                >
                  &ensp;&ensp;&ensp;&ensp;&ensp;Aspek Administrasi
                </NavLink>
                <NavLink
                  className={indikatorKesehatan ? (path === "indikator-kesehatan" ? "sidebar-active" : "d-block") : "d-none"}
                  tag={Link}
                  to="/indikator-kesehatan"
                >
                  &ensp;&ensp;&ensp;&ensp;&ensp;Indikator Kesehatan
                </NavLink>
                {/* <NavLink
                  className={
                    indikatorKesehatan ? (path === "setting-indikator-kesehatan" ? "sidebar-active" : "d-block") : "d-none"
                  }
                  tag={Link}
                  to="/setting-indikator-kesehatan"
                >
                  &ensp;&ensp;&ensp;&ensp;&ensp;Setting
                </NavLink> */}
              </>
            ) : (
              <>
                <NavLink
                  className={indikatorKesehatan ? (path === "aspek-keuangan" ? "sidebar-active" : "d-block") : "d-none"}
                  tag={Link}
                  to="/aspek-keuangan"
                >
                  &ensp;&ensp;&ensp;&ensp;&ensp;Aspek Keuangan
                </NavLink>
                <NavLink
                  className={indikatorKesehatan ? (path === "aspek-operasional" ? "sidebar-active" : "d-block") : "d-none"}
                  tag={Link}
                  to="/aspek-operasional"
                >
                  &ensp;&ensp;&ensp;&ensp;&ensp;Aspek Operasional
                </NavLink>
                <NavLink
                  className={indikatorKesehatan ? (path === "indikator-kesehatan" ? "sidebar-active" : "d-block") : "d-none"}
                  tag={Link}
                  to="/indikator-kesehatan"
                >
                  &ensp;&ensp;&ensp;&ensp;&ensp;Indikator Kesehatan
                </NavLink>
              </>
            )}
            {(user.role === 4 || user.role === 5) && (
              <NavLink className={path === "approval" ? "sidebar-active" : ""} tag={Link} to="/approval">
                <span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path
                        d="M11.6668 1.66602H5.00016C4.55814 1.66602 4.13421 1.84161 3.82165 2.15417C3.50909 2.46673 3.3335 2.89065 3.3335 3.33268V16.666C3.3335 17.108 3.50909 17.532 3.82165 17.8445C4.13421 18.1571 4.55814 18.3327 5.00016 18.3327H15.0002C15.4422 18.3327 15.8661 18.1571 16.1787 17.8445C16.4912 17.532 16.6668 17.108 16.6668 16.666V6.66602L11.6668 1.66602Z"
                        stroke="white"
                        strokeOpacity="0.8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11.6665 1.66602V6.66602H16.6665"
                        stroke="white"
                        strokeOpacity="0.8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3332 10.834H6.6665"
                        stroke="white"
                        strokeOpacity="0.8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3332 14.166H6.6665"
                        stroke="white"
                        strokeOpacity="0.8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.33317 7.5H7.49984H6.6665"
                        stroke="white"
                        strokeOpacity="0.8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </svg>
                </span>
                &nbsp;&nbsp;Approval
              </NavLink>
            )}
            <NavLink className={path === "financial-statement" ? "sidebar-active" : ""} tag={Link} to="/financial-statement">
              <span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 20V10" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 20V4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6 20V14" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              &nbsp;&nbsp;Ringkasan Keuangan
            </NavLink>
            {user.role >= 4 && (
              <NavLink className={path === "document" ? "sidebar-active" : ""} tag={Link} to="/document">
                <Icon name="upload" />
                &nbsp;&nbsp;Upload Data
              </NavLink>
            )}
            {user.role < 4 && (
              <NavLink className={path === "perusahaan" ? "sidebar-active" : ""} tag={Link} to="/perusahaan">
                <span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path
                        d="M16.666 5.83301H3.33268C2.41221 5.83301 1.66602 6.5792 1.66602 7.49967V15.833C1.66602 16.7535 2.41221 17.4997 3.33268 17.4997H16.666C17.5865 17.4997 18.3327 16.7535 18.3327 15.833V7.49967C18.3327 6.5792 17.5865 5.83301 16.666 5.83301Z"
                        stroke="white"
                        strokeOpacity="0.8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3327 17.5V4.16667C13.3327 3.72464 13.1571 3.30072 12.8445 2.98816C12.532 2.67559 12.108 2.5 11.666 2.5H8.33268C7.89065 2.5 7.46673 2.67559 7.15417 2.98816C6.84161 3.30072 6.66602 3.72464 6.66602 4.16667V17.5"
                        stroke="white"
                        strokeOpacity="0.8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </svg>
                </span>
                &nbsp;&nbsp;Perusahaan
              </NavLink>
            )}
            <NavLink className={path === "daftar-aset" ? "sidebar-active" : ""} tag={Link} to="/daftar-aset">
              <span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0)">
                    <path
                      d="M14.1663 17.5V15.8333C14.1663 14.9493 13.8152 14.1014 13.19 13.4763C12.5649 12.8512 11.7171 12.5 10.833 12.5H4.16634C3.28229 12.5 2.43444 12.8512 1.80932 13.4763C1.1842 14.1014 0.833008 14.9493 0.833008 15.8333V17.5"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.50033 9.16667C9.34128 9.16667 10.8337 7.67428 10.8337 5.83333C10.8337 3.99238 9.34128 2.5 7.50033 2.5C5.65938 2.5 4.16699 3.99238 4.16699 5.83333C4.16699 7.67428 5.65938 9.16667 7.50033 9.16667Z"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M19.167 17.4991V15.8324C19.1664 15.0939 18.9206 14.3764 18.4681 13.7927C18.0156 13.209 17.3821 12.7921 16.667 12.6074"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.333 2.60742C14.05 2.79101 14.6855 3.20801 15.1394 3.79268C15.5932 4.37735 15.8395 5.09645 15.8395 5.83659C15.8395 6.57673 15.5932 7.29582 15.1394 7.8805C14.6855 8.46517 14.05 8.88217 13.333 9.06576"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </span>
              &nbsp;&nbsp;Daftar Aset
            </NavLink>
            <NavLink className={path === "pegawai" ? "sidebar-active" : ""} tag={Link} to="/pegawai">
              <span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0)">
                    <path
                      d="M14.1663 17.5V15.8333C14.1663 14.9493 13.8152 14.1014 13.19 13.4763C12.5649 12.8512 11.7171 12.5 10.833 12.5H4.16634C3.28229 12.5 2.43444 12.8512 1.80932 13.4763C1.1842 14.1014 0.833008 14.9493 0.833008 15.8333V17.5"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7.50033 9.16667C9.34128 9.16667 10.8337 7.67428 10.8337 5.83333C10.8337 3.99238 9.34128 2.5 7.50033 2.5C5.65938 2.5 4.16699 3.99238 4.16699 5.83333C4.16699 7.67428 5.65938 9.16667 7.50033 9.16667Z"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M19.167 17.4991V15.8324C19.1664 15.0939 18.9206 14.3764 18.4681 13.7927C18.0156 13.209 17.3821 12.7921 16.667 12.6074"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.333 2.60742C14.05 2.79101 14.6855 3.20801 15.1394 3.79268C15.5932 4.37735 15.8395 5.09645 15.8395 5.83659C15.8395 6.57673 15.5932 7.29582 15.1394 7.8805C14.6855 8.46517 14.05 8.88217 13.333 9.06576"
                      stroke="white"
                      strokeOpacity="0.8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </svg>
              </span>
              &nbsp;&nbsp;Pegawai
            </NavLink>

            <NavLink className={path === "event" ? "sidebar-active" : ""} tag={Link} to="/event">
              <span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.66602 2.5H6.66602C7.55007 2.5 8.39792 2.85119 9.02304 3.47631C9.64816 4.10143 9.99935 4.94928 9.99935 5.83333V17.5C9.99935 16.837 9.73596 16.2011 9.26712 15.7322C8.79828 15.2634 8.16239 15 7.49935 15H1.66602V2.5Z"
                    stroke="#FFF"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.3333 2.5H13.3333C12.4493 2.5 11.6014 2.85119 10.9763 3.47631C10.3512 4.10143 10 4.94928 10 5.83333V17.5C10 16.837 10.2634 16.2011 10.7322 15.7322C11.2011 15.2634 11.837 15 12.5 15H18.3333V2.5Z"
                    stroke="#FFF"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              &nbsp;&nbsp;Event
            </NavLink>
            {/* <NavLink
              className={konten ? (path === "berita" ? "sidebar-active" : "d-block") : "d-none"}
              tag={Link}
              to="/berita"
            >
              &ensp;&ensp;&ensp;&ensp;&nbsp;Berita
            </NavLink>
            <NavLink
              className={konten ? (path === "event" ? "sidebar-active" : "d-block") : "d-none"}
              tag={Link}
              to="/event"
            >
              &ensp;&ensp;&ensp;&ensp;&nbsp;Event
            </NavLink> */}
            {isBiro() &&
              <NavLink className={path === "akun" ? "sidebar-active" : ""} tag={Link} to="/akun">
                <span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                      stroke="#fff"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                      stroke="#fff"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                &nbsp;&nbsp;Akun Pengguna
              </NavLink>
            }
            {user.role < 4 && (
              <>
                <NavLink className={path === "activity" ? "sidebar-active" : ""} tag={Link} to="/activity">
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0)">
                        <path
                          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                          stroke="white"
                          strokeOpacity="0.8"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M16.1673 12.5006C16.0564 12.752 16.0233 13.0308 16.0723 13.3011C16.1213 13.5715 16.2502 13.8209 16.4423 14.0173L16.4923 14.0673C16.6473 14.2221 16.7702 14.4059 16.8541 14.6082C16.938 14.8106 16.9811 15.0275 16.9811 15.2465C16.9811 15.4655 16.938 15.6824 16.8541 15.8847C16.7702 16.087 16.6473 16.2709 16.4923 16.4256C16.3375 16.5806 16.1537 16.7035 15.9514 16.7874C15.7491 16.8713 15.5322 16.9145 15.3131 16.9145C15.0941 16.9145 14.8772 16.8713 14.6749 16.7874C14.4726 16.7035 14.2888 16.5806 14.134 16.4256L14.084 16.3756C13.8876 16.1835 13.6381 16.0547 13.3678 16.0056C13.0975 15.9566 12.8187 15.9897 12.5673 16.1006C12.3208 16.2063 12.1106 16.3817 11.9626 16.6053C11.8145 16.8288 11.7351 17.0908 11.734 17.359V17.5006C11.734 17.9427 11.5584 18.3666 11.2458 18.6792C10.9333 18.9917 10.5093 19.1673 10.0673 19.1673C9.62529 19.1673 9.20137 18.9917 8.88881 18.6792C8.57625 18.3666 8.40065 17.9427 8.40065 17.5006V17.4256C8.3942 17.1498 8.30492 16.8823 8.14441 16.6579C7.9839 16.4335 7.7596 16.2626 7.50065 16.1673C7.2493 16.0564 6.97049 16.0233 6.70016 16.0723C6.42983 16.1213 6.18038 16.2502 5.98398 16.4423L5.93398 16.4923C5.7792 16.6473 5.59538 16.7702 5.39305 16.8541C5.19072 16.938 4.97384 16.9811 4.75482 16.9811C4.53579 16.9811 4.31891 16.938 4.11658 16.8541C3.91425 16.7702 3.73044 16.6473 3.57565 16.4923C3.42069 16.3375 3.29776 16.1537 3.21388 15.9514C3.13001 15.7491 3.08684 15.5322 3.08684 15.3131C3.08684 15.0941 3.13001 14.8772 3.21388 14.6749C3.29776 14.4726 3.42069 14.2888 3.57565 14.134L3.62565 14.084C3.81776 13.8876 3.94664 13.6381 3.99565 13.3678C4.04467 13.0975 4.01158 12.8187 3.90065 12.5673C3.79501 12.3208 3.61961 12.1106 3.39604 11.9626C3.17246 11.8145 2.91047 11.7351 2.64232 11.734H2.50065C2.05862 11.734 1.6347 11.5584 1.32214 11.2458C1.00958 10.9333 0.833984 10.5093 0.833984 10.0673C0.833984 9.62529 1.00958 9.20137 1.32214 8.88881C1.6347 8.57625 2.05862 8.40065 2.50065 8.40065H2.57565C2.85148 8.3942 3.11899 8.30492 3.3434 8.14441C3.56781 7.9839 3.73875 7.7596 3.83398 7.50065C3.94491 7.2493 3.978 6.97049 3.92899 6.70016C3.87997 6.42983 3.7511 6.18038 3.55898 5.98398L3.50898 5.93398C3.35402 5.7792 3.23109 5.59538 3.14722 5.39305C3.06334 5.19072 3.02017 4.97384 3.02017 4.75482C3.02017 4.53579 3.06334 4.31891 3.14722 4.11658C3.23109 3.91425 3.35402 3.73044 3.50898 3.57565C3.66377 3.42069 3.84759 3.29776 4.04992 3.21388C4.25225 3.13001 4.46912 3.08684 4.68815 3.08684C4.90718 3.08684 5.12405 3.13001 5.32638 3.21388C5.52871 3.29776 5.71253 3.42069 5.86732 3.57565L5.91732 3.62565C6.11372 3.81776 6.36316 3.94664 6.63349 3.99565C6.90382 4.04467 7.18264 4.01158 7.43398 3.90065H7.50065C7.74712 3.79501 7.95733 3.61961 8.10539 3.39604C8.25346 3.17246 8.33291 2.91047 8.33398 2.64232V2.50065C8.33398 2.05862 8.50958 1.6347 8.82214 1.32214C9.1347 1.00958 9.55862 0.833984 10.0007 0.833984C10.4427 0.833984 10.8666 1.00958 11.1792 1.32214C11.4917 1.6347 11.6673 2.05862 11.6673 2.50065V2.57565C11.6684 2.84381 11.7478 3.1058 11.8959 3.32937C12.044 3.55295 12.2542 3.72835 12.5006 3.83398C12.752 3.94491 13.0308 3.978 13.3011 3.92899C13.5715 3.87997 13.8209 3.7511 14.0173 3.55898L14.0673 3.50898C14.2221 3.35402 14.4059 3.23109 14.6082 3.14722C14.8106 3.06334 15.0275 3.02017 15.2465 3.02017C15.4655 3.02017 15.6824 3.06334 15.8847 3.14722C16.087 3.23109 16.2709 3.35402 16.4256 3.50898C16.5806 3.66377 16.7035 3.84759 16.7874 4.04992C16.8713 4.25225 16.9145 4.46912 16.9145 4.68815C16.9145 4.90718 16.8713 5.12405 16.7874 5.32638C16.7035 5.52871 16.5806 5.71253 16.4256 5.86732L16.3756 5.91732C16.1835 6.11372 16.0547 6.36316 16.0056 6.63349C15.9566 6.90382 15.9897 7.18264 16.1006 7.43398V7.50065C16.2063 7.74712 16.3817 7.95733 16.6053 8.10539C16.8288 8.25346 17.0908 8.33291 17.359 8.33398H17.5006C17.9427 8.33398 18.3666 8.50958 18.6792 8.82214C18.9917 9.1347 19.1673 9.55862 19.1673 10.0007C19.1673 10.4427 18.9917 10.8666 18.6792 11.1792C18.3666 11.4917 17.9427 11.6673 17.5006 11.6673H17.4256C17.1575 11.6684 16.8955 11.7478 16.6719 11.8959C16.4484 12.044 16.273 12.2542 16.1673 12.5006V12.5006Z"
                          stroke="white"
                          strokeOpacity="0.8"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </svg>
                  </span>
                  &nbsp;&nbsp;Aktivitas Akun
                </NavLink>
              </>
            )}
          </NavItem>
        </Nav>
      </div>
    </div>
  );
};
